<ng1-permission-to-walk [selectedPerson]="selectedPerson"></ng1-permission-to-walk>
